import React, {Component} from "react";
import {Button} from "react-bootstrap";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import NotificationService from "../../../../services/notification-service/NotificationService";

export default class AddRemittanceModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            file: null,
            uploading: false,
            result: null
        };
    }

    handleFileChange = (e) => {
        this.setState({file: e.target.files[0], result: null});
    }

    handleUpload = () => {
        if (!this.state.file) return;

        this.setState({uploading: true});

        const formData = new FormData();
        formData.append("file", this.state.file);

        RemotingService.instance.post("api/insurance/coordinator/v2/claims/claim-remittance/upload", formData, {
            headers: {"Content-Type": "multipart/form-data"}
        }).then((response) => {
            const result = response.data.data;
            this.setState({uploading: false, result});
            if (result.success) {
                NotificationService.showNotification({severity: 'success', summary: 'Remittance uploaded successfully'});
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                }
            }
        }).catch(() => {
            this.setState({uploading: false});
            NotificationService.showNotification({severity: 'error', summary: 'Failed to upload remittance'});
        });
    }

    render() {
        const {result} = this.state;

        return (
            <div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">XML</label>
                    <div className="col-sm-10">
                        <input type="file" className="form-control-file" accept=".xml"
                               onChange={this.handleFileChange}/>
                    </div>
                </div>
                <div className="text-right mb-3">
                    <Button variant="primary" disabled={!this.state.file || this.state.uploading}
                            onClick={this.handleUpload}>
                        {this.state.uploading ? "Uploading..." : "Upload"}
                    </Button>
                </div>

                {result && result.success &&
                    <div className="alert alert-success">
                        <h6>Remittance added successfully!</h6>
                        <ul>
                            {result.claims.map((c, i) =>
                                <li key={i}>Remittance submitted for claim {c.claimId}</li>
                            )}
                        </ul>
                    </div>
                }

                {result && !result.success &&
                    <div className="alert alert-danger">
                        <h6>Missing Claims!</h6>
                        <ul>
                            {result.claims.map((c, i) =>
                                <li key={i}>
                                    {c.found
                                        ? <span>&#x2705; claim {c.claimId} was found</span>
                                        : <span>&#x274C; claim {c.claimId} was <b>not found</b>
                                            {c.suggestedClaimId && <span> -- maybe {c.suggestedClaimId}?</span>}
                                          </span>
                                    }
                                </li>
                            )}
                        </ul>
                    </div>
                }
            </div>
        );
    }
}
